@if (mode() === 'dropdown') {
  <oiq-ui-dropdown #providerDropdown="OiqUiDropdown">
    <button class="provider-switch-button" type="button" (click)="providerDropdown.toggle()">
      {{ currentProviderText() }}
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 1.5L6 6.5L11 1.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <ng-template #dropdownTemplate>
      <div class="provider-dropdown-menu">
        <!-- Authenticated providers - can switch to them -->
        @for (provider of allConnectedProviders(); track provider.email) {
          <button
            class="provider-option"
            type="button"
            (click)="onProviderSelect(provider.value, provider.email)">
            <img [src]="provider.icon" [alt]="provider.label" class="provider-icon" />
            <span>{{ provider.email || provider.label }}</span>
          </button>
        }

        <div class="provider-separator"></div>
        <div class="flex px-4 py-2">
          <button
            class="oiq-button oiq-button--primary--link z-10 flex items-center gap-1 p-0 text-sm hover:bg-white"
            type="button"
            (click)="addMailboxClicked.emit(); providerDropdown.close()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none">
              <path
                d="M6.5 0C5.21442 0 3.95772 0.381218 2.8888 1.09545C1.81988 1.80968 0.986756 2.82484 0.494786 4.01256C0.00281635 5.20028 -0.125905 6.50721 0.124899 7.76809C0.375703 9.02896 0.994767 10.1872 1.90381 11.0962C2.81285 12.0052 3.97104 12.6243 5.23192 12.8751C6.49279 13.1259 7.79973 12.9972 8.98744 12.5052C10.1752 12.0132 11.1903 11.1801 11.9046 10.1112C12.6188 9.04229 13 7.78558 13 6.5C12.9982 4.77665 12.3128 3.12441 11.0942 1.90582C9.87559 0.687224 8.22335 0.00181989 6.5 0ZM6.5 12C5.41221 12 4.34884 11.6774 3.44437 11.0731C2.5399 10.4687 1.83495 9.60975 1.41867 8.60476C1.00238 7.59977 0.893465 6.4939 1.10568 5.427C1.3179 4.36011 1.84173 3.3801 2.61092 2.61091C3.3801 1.84172 4.36011 1.3179 5.42701 1.10568C6.4939 0.893462 7.59977 1.00238 8.60476 1.41866C9.60976 1.83494 10.4687 2.53989 11.0731 3.44436C11.6774 4.34883 12 5.4122 12 6.5C11.9983 7.95818 11.4184 9.35617 10.3873 10.3873C9.35617 11.4184 7.95819 11.9983 6.5 12ZM9.5 6.5C9.5 6.63261 9.44732 6.75979 9.35356 6.85355C9.25979 6.94732 9.13261 7 9 7H7V9C7 9.13261 6.94732 9.25979 6.85356 9.35355C6.75979 9.44732 6.63261 9.5 6.5 9.5C6.36739 9.5 6.24022 9.44732 6.14645 9.35355C6.05268 9.25979 6 9.13261 6 9V7H4C3.86739 7 3.74022 6.94732 3.64645 6.85355C3.55268 6.75979 3.5 6.63261 3.5 6.5C3.5 6.36739 3.55268 6.24021 3.64645 6.14645C3.74022 6.05268 3.86739 6 4 6H6V4C6 3.86739 6.05268 3.74021 6.14645 3.64645C6.24022 3.55268 6.36739 3.5 6.5 3.5C6.63261 3.5 6.75979 3.55268 6.85356 3.64645C6.94732 3.74021 7 3.86739 7 4V6H9C9.13261 6 9.25979 6.05268 9.35356 6.14645C9.44732 6.24021 9.5 6.36739 9.5 6.5Z"
                fill="#FF5127" />
            </svg>
            Add Mailbox
          </button>
        </div>
      </div>
    </ng-template>
  </oiq-ui-dropdown>
}

@if (mode() === 'mailbox') {
  <div class="flex flex-col gap-2">
    @for (provider of allConnectedProviders(); track provider.email) {
      <div class="flex items-center justify-between gap-8 rounded-[6px] bg-slate-100 px-3 py-1">
        <button
          class="flex flex-row items-center gap-3"
          type="button"
          (click)="onProviderSelect(provider.value, provider.email)">
          <img [src]="provider.icon" [alt]="provider.label" class="provider-icon" />
          <div class="flex flex-col items-start">
            <span class="text-sm font-medium text-gray-500">{{ provider.label }}</span>
            <span class="text-xs text-gray-400">{{ provider.email || provider.label }}</span>
          </div>
        </button>

        <div class="flex">
          <!-- Log Out Provider -->
          <button
            type="button"
            class="group flex items-center gap-1 rounded px-2 py-1 text-error hover:bg-red-400 hover:text-white"
            aria-label="Log Out {{ provider.label }}"
            (click)="onDisconnectProvider(provider.value, provider.email)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.5 13.5C7.5 13.6326 7.44732 13.7598 7.35355 13.8536C7.25979 13.9473 7.13261 14 7 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8536C2.55268 13.7598 2.5 13.6326 2.5 13.5V2.5C2.5 2.36739 2.55268 2.24021 2.64645 2.14645C2.74021 2.05268 2.86739 2 3 2H7C7.13261 2 7.25979 2.05268 7.35355 2.14645C7.44732 2.24021 7.5 2.36739 7.5 2.5C7.5 2.63261 7.44732 2.75979 7.35355 2.85355C7.25979 2.94732 7.13261 3 7 3H3.5V13H7C7.13261 13 7.25979 13.0527 7.35355 13.1464C7.44732 13.2402 7.5 13.3674 7.5 13.5ZM14.3538 7.64625L11.8538 5.14625C11.7599 5.05243 11.6327 4.99972 11.5 4.99972C11.3673 4.99972 11.2401 5.05243 11.1462 5.14625C11.0524 5.24007 10.9997 5.36732 10.9997 5.5C10.9997 5.63268 11.0524 5.75993 11.1462 5.85375L12.7931 7.5H7C6.86739 7.5 6.74021 7.55268 6.64645 7.64645C6.55268 7.74021 6.5 7.86739 6.5 8C6.5 8.13261 6.55268 8.25979 6.64645 8.35355C6.74021 8.44732 6.86739 8.5 7 8.5H12.7931L11.1462 10.1462C11.0524 10.2401 10.9997 10.3673 10.9997 10.5C10.9997 10.6327 11.0524 10.7599 11.1462 10.8538C11.2401 10.9476 11.3673 11.0003 11.5 11.0003C11.6327 11.0003 11.7599 10.9476 11.8538 10.8538L14.3538 8.35375C14.4002 8.30731 14.4371 8.25217 14.4623 8.19147C14.4874 8.13077 14.5004 8.06571 14.5004 8C14.5004 7.93429 14.4874 7.86923 14.4623 7.80853C14.4371 7.74783 14.4002 7.69269 14.3538 7.64625Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
}
